<template>
  <div>
    <panel title="Schemy">
      <w-table
        entity-type="schema"
        :columns="columns"
        :data="list"
        :actions="actions"
        :total="count"
        :per-page="0"
        @add="showAddModal"
        @edit="showEditModal($event.id)"
        @delete="showDeleteDialog($event.id)"
      />
    </panel>

    <schema-modal :id="idToEdit" :show="showModal" @save="add" @close="hideModal" @update="update" />
  </div>
</template>

<script>
import SchemaModal from '@/components/modals/SchemaModal';
import Panel from '@/components/panel/Panel';
import WTable from '@/components/table/Table';
import { listMixin } from '@/mixins/list';
import { DEFAULT_TABLE_ACTIONS } from '@/utils/constants';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania schem.',
  getError: 'Wystąpił błąd podczas pobierania danych schemy.',
  added: 'Dodano schemę.',
  addError: 'Nie udało się dodać schemy.',
  updated: 'Zaktualizowano dane schemy.',
  updateError: 'Nie udało się zaktualizować danych schemy.',
  deleteConfirm: 'Czy na pewno chcesz usunąć schemę?',
  deleted: 'Usunięto schemę.',
  deleteError: 'Nie udało się usunąć schemy.'
};

// @vuese
// Lista schem
// @group schema
export default {
  components: { Panel, WTable, SchemaModal },
  mixins: [listMixin('schema', messages, { count: -1 })],
  data: () => ({
    columns: [
      { name: 'id', displayName: 'ID' },
      { name: 'name', displayName: 'Nazwa', sortable: true }
    ],
    actions: DEFAULT_TABLE_ACTIONS
  })
};
</script>
